<template>
	<div
		class="single--event will-change"
		:data-scroll-section="inner == 'false'"
	>
		<!-- Hero -->
		<div class="hero h-auto xl:h-screen w-full relative overflow-hidden">
			<div class="hero__img-wraper xl:px-content pt-[96px] xl:pt-[180px]">
				<img
					class="object-cover w-full h-auto"
					v-show="fieldsData.image"
					:src="fieldsData.image.sizes.eventhero"
					:alt="fieldsData.image.alt"
				/>
			</div>
		</div>
		<!-- ./Hero -->
		<section class="px-content py-12 xl:py-20 flex flex-col xl:flex-row">
			<!-- text -->
			<div class="xl:w-1/2 xl:pr-[108px]">
				<div
					class="tracking-desk text-sm mb-5 xl:mb-7 leading-5 uppercase"
					v-show="postData.event_category"
					v-html="postData.event_category[0].name"
				></div>
				<h1
					class="text-4xl xl:text-heading mb-8 leading-none text-navy-blue-01"
					v-show="postData.post_title"
					v-html="postData.post_title"
				></h1>
				<p v-show="fieldsData.text" v-html="fieldsData.text"></p>
				<div
					class="mt-12"
					v-show="fieldsData.price_adults || fieldsData.price_kids"
				>
					<div class="tracking-desk text-sm mb-7 leading-tight uppercase">
						{{ __("Entry price", "ccave") }}
					</div>
					<dl class="flex">
						<div class="mr-14" v-show="fieldsData.price_adults">
							<dt class="text-sm leading-5 text-navy-blue-03 mb-2">
								{{ __("Adults", "ccave") }}
							</dt>
							<dd
								class="text-2xl leading-7 tracking-[1px] text-navy-blue-01 font-canela font-normal xl:font-light"
							>
								{{ fieldsData.price_adults }}
							</dd>
						</div>
						<div v-show="fieldsData.price_kids">
							<dt class="text-sm leading-5 text-navy-blue-03 mb-2">
								{{ __("Kids", "ccave") }}
							</dt>
							<dd
								class="text-2xl leading-7 tracking-[1px] text-navy-blue-01 font-canela font-normal xl:font-light"
							>
								{{ fieldsData.price_kids }}
							</dd>
						</div>
					</dl>

					<!-- Form for reservation -->
					<div v-if="fieldsData.form_shortcode" class="mt-10 xl:mt-16">
						<div
							class="text-sm tracking-desk text-navy-blue-03 uppercase mb-10"
						>
							{{ __("Make reservation", "ccave") }}
						</div>
						<div v-html="fieldsData.form_shortcode"></div>
					</div>
					<!-- ./Form for reservation -->

					<!-- <button
						class="btn btn-blue"
						v-show="fieldsData.reservations === '1'"
						@click="doReservation()"
					>
						MAKE RESERVATION
					</button> -->
				</div>
				<a :href="ctaLink">
					<img
						:src="ctaImage"
						:style="{ marginTop: '24px' }"
						alt="Call to Action"
					/>
				</a>
			</div>
			<!-- ./text -->
			<!-- separator -->
			<div
				class="bg-light-grey h-[1px] xl:h-auto w-full xl:w-[1px] self-stretch my-14 xl:mt-0"
			></div>
			<!-- ./separator -->
			<div class="xl:w-1/2 xl:pl-[76px]">
				<dl class="grid grid-cols-1 md:grid-cols-2 gap-[30px]">
					<div class="mb-4" v-if="allEventDates.length && selectedDate">
						<dt class="tracking-desk text-sm leading-tight uppercase mb-6">
							{{ __("WHEN", "ccave") }}
						</dt>

						<dd class="flex flex-col gap-2">
							<!-- Active date -->
							<div class="font-semibold">
								{{ formatDate(selectedDate, "dd MMMM") }}
							</div>

							<!-- Event time -->
							<div>
								{{ eventTime }}
							</div>

							<!-- Other dates -->
							<!-- <div v-if="otherDates.length" class="mt-2 opacity-60 text-sm">
								<div class="uppercase tracking-desk mb-1">
									{{ __("Other dates", "ccave") }}
								</div>

								<ul class="flex flex-col gap-1">
									<li v-for="date in otherDates" :key="date">
										{{ formatDate(date, "dd MMMM") }}
									</li>
								</ul>
							</div> -->
						</dd>
					</div>
					<div class="mb-4" v-show="fieldsData.start">
						<dt class="tracking-desk text-sm leading-tight uppercase mb-6">
							{{ __("WHERE", "ccave") }}
						</dt>
						<dd class="flex">
							<div>
								<svg
									class="mr-4"
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M12 12.75C13.6569 12.75 15 11.4069 15 9.75C15 8.09315 13.6569 6.75 12 6.75C10.3431 6.75 9 8.09315 9 9.75C9 11.4069 10.3431 12.75 12 12.75Z"
										stroke="#405664"
										stroke-width="1.2"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
									<path
										d="M19.5 9.75C19.5 16.5 12 21.75 12 21.75C12 21.75 4.5 16.5 4.5 9.75C4.5 7.76088 5.29018 5.85322 6.6967 4.4467C8.10322 3.04018 10.0109 2.25 12 2.25C13.9891 2.25 15.8968 3.04018 17.3033 4.4467C18.7098 5.85322 19.5 7.76088 19.5 9.75V9.75Z"
										stroke="#405664"
										stroke-width="1.2"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
								</svg>
							</div>
							<div v-show="fieldsData.location.markers">
								{{ fieldsData.location.markers[0].location_name.name }}
							</div>
						</dd>
					</div>
				</dl>
				<!-- map -->
				<!-- <img class="my-10" src="https://picsum.photos/515/250" alt=""> -->
				<div id="map" class="my-8" style="height: 300px"></div>
				<!-- ./map -->
				<div>
					<div class="tracking-desk text-sm mb-7 leading-tight uppercase">
						{{ __("contact", "ccave") }}
					</div>
					<div class="flex items-center mb-7">
						<svg
							class="mr-4"
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M8.66965 11.7024C9.44762 13.2929 10.7369 14.5763 12.3309 15.347C12.4475 15.4023 12.5765 15.4262 12.7052 15.4165C12.8339 15.4067 12.9579 15.3636 13.0648 15.2915L15.4119 13.7264C15.5157 13.6572 15.6352 13.6149 15.7594 13.6035C15.8837 13.5921 16.0088 13.6119 16.1235 13.661L20.5144 15.5428C20.6636 15.6062 20.7881 15.7163 20.8693 15.8566C20.9504 15.9969 20.9838 16.1598 20.9643 16.3207C20.8255 17.4067 20.2956 18.4049 19.4739 19.1283C18.6521 19.8518 17.5948 20.2509 16.5 20.2509C13.1185 20.2509 9.87548 18.9076 7.48439 16.5166C5.0933 14.1255 3.75 10.8825 3.75 7.50095C3.75006 6.40611 4.14918 5.34883 4.87264 4.52708C5.5961 3.70533 6.59428 3.17545 7.68028 3.03667C7.84117 3.0172 8.00403 3.05054 8.14432 3.13167C8.28461 3.21281 8.39473 3.33734 8.4581 3.4865L10.3416 7.8813C10.3903 7.99497 10.4101 8.11893 10.3994 8.24214C10.3886 8.36534 10.3475 8.48397 10.2798 8.58745L8.72011 10.9705C8.64912 11.0778 8.60716 11.2015 8.59831 11.3298C8.58947 11.4581 8.61405 11.5864 8.66965 11.7024V11.7024Z"
								stroke="#405664"
								stroke-width="1.2"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
						</svg>
						<a class="underline" href="tel:+38267143818">+38267143818</a>
					</div>
					<div class="flex items-center">
						<svg
							class="mr-4"
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M3 5.25H21V18C21 18.1989 20.921 18.3897 20.7803 18.5303C20.6397 18.671 20.4489 18.75 20.25 18.75H3.75C3.55109 18.75 3.36032 18.671 3.21967 18.5303C3.07902 18.3897 3 18.1989 3 18V5.25Z"
								stroke="#405664"
								stroke-width="1.2"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path
								d="M21 5.25L12 13.5L3 5.25"
								stroke="#405664"
								stroke-width="1.2"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
						</svg>
						<a class="underline" href="mailto:events@lusticabay.com"
							>events@lusticabay.com</a
						>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import { addDays, format, parseISO } from "date-fns";
import mapboxgl from "mapbox-gl";
export default {
	name: "SingleEvent",
	data() {
		return {
			map: false,
			language: document.documentElement.lang || "en",
			ctaData: {
				en: {
					link: "https://lusticabay.com/events-and-experiences-lustica-bay/",
					image:
						"https://lusticabay.com/wp-content/uploads/2026/02/Event-Calendar-Banner-EN.png",
				},
				"de-DE": {
					link: "https://lusticabay.com/de/events-and-experiences/",
					image:
						"https://lusticabay.com/wp-content/uploads/2026/02/Event-Calendar-Banner-DE.png",
				},
				"ru-RU": {
					link: "https://lusticabay.com/ru/events-and-experiences/",
					image:
						"https://lusticabay.com/wp-content/uploads/2026/02/Event-Calendar-Banner-RU.png",
				},
				"sr-ME": {
					link: "https://lusticabay.com/me/events-and-experiences/",
					image:
						"https://lusticabay.com/wp-content/uploads/2026/02/Event-Calendar-Banner-MN.png",
				},
			},
		};
	},
	computed: {
		ctaLink() {
			return (
				(this.ctaData[this.language] && this.ctaData[this.language].link) ||
				this.ctaData.en.link
			);
		},
		ctaImage() {
			return (
				(this.ctaData[this.language] && this.ctaData[this.language].image) ||
				this.ctaData.en.image
			);
		},
		eventEndDate() {
			if (!this.fieldsData.repeat_period) return null;
			return addDays(
				parseISO(this.fieldsData.start),
				this.fieldsData.repeat_period
			);
		},
		// Array of all dates for this event
		allEventDates() {
			if (!this.fieldsData?.start) return [];

			const startDate = parseISO(this.fieldsData.start);
			const untilDate = this.fieldsData.until
				? parseISO(this.fieldsData.until)
				: startDate;
			const repeatDays = Number(this.fieldsData.repeat || 0);

			const dates = [startDate];

			if (repeatDays > 0) {
				let current = addDays(startDate, repeatDays);
				while (current <= untilDate) {
					dates.push(current);
					current = addDays(current, repeatDays);
				}
			}

			return dates;
		},

		selectedDate() {
			if (!this.allEventDates.length) return null;

			const params = new URLSearchParams(window.location.search);
			const paramDate = params.get("event_date");

			if (paramDate) {
				// Find exact match
				const match = this.allEventDates.find(
					(d) => format(d, "yyyy-MM-dd") === paramDate
				);

				if (match) return match;

				// Find closest future date relative to paramDate
				const next = this.allEventDates.find(
					(d) => format(d, "yyyy-MM-dd") > paramDate
				);

				if (next) return next;
			}

			// If no param or param is after all events - fallback to oldest
			return this.allEventDates[0];
		},

		// otherDates() {
		// 	if (!this.selectedDate) return [];
		// 	return this.allEventDates.filter(
		// 	d => format(d, "yyyy-MM-dd") !== format(this.selectedDate, "yyyy-MM-dd")
		// 	);
		// },

		eventTime() {
			return this.fieldsData?.start && this.fieldsData?.end
				? `${this.formatTime(this.fieldsData.start)} - ${this.formatTime(
						this.fieldsData.end
				  )}`
				: "";
		},
	},
	mounted() {
		mapboxgl.accessToken = this.fieldsData.location.map_settings.access_token;
		this.map = new mapboxgl.Map({
			container: "map", // container ID
			style: this.fieldsData.location.map_settings.style, // style URL
			center: this.fieldsData.location.map_settings.center, // starting position
			zoom: this.fieldsData.location.map_settings.zoom, // starting zoom
			pitch: this.fieldsData.location.map_settings.pitch,
			bearing: this.fieldsData.location.map_settings.bearing,
		});

		this.map.on("load", () => {
			let mapData = JSON.parse(this.fieldsData.location.markers[0].map_data);
			this.map.loadImage(
				this.endpoints.template_url + "/assets/img/dot-circle-black.png",
				(error, image) => {
					if (error) throw error;
					this.map.addImage("custom-marker", image);
					// Add a GeoJSON source with 2 points
					this.map.addSource("points", {
						type: "geojson",
						data: mapData,
					});

					// Add a symbol layer
					this.map.addLayer({
						id: "points",
						type: "symbol",
						source: "points",
						layout: {
							"icon-image": "custom-marker",
							"icon-allow-overlap": true,
						},
					});
				}
			);
		});
		let wpcf7Elm = this.$el.querySelector(".wpcf7");
		if (wpcf7Elm) {
			wpcf7Elm.addEventListener(
				"wpcf7submit",
				(event) => {
					event.detail.apiResponse.invalid_fields.forEach((el) => {
						let parent = this.$el
							.querySelectorAll(el.into)[0]
							.closest(".form-control");
						parent.classList.add("invalid-input");
					});
				},
				false
			);
			this.$el.querySelectorAll("form")[0].addEventListener("submit", () => {
				this.$el
					.querySelectorAll(".form-control.invalid-input")
					.forEach((el) => {
						el.classList.remove("invalid-input");
					});
			});
			this.$el.querySelector('[name="event_data"]').value =
				this.postData.post_title;
		}
	},
	methods: {
		formatDate(date) {
			if (!date) return "";

			// If date is a string, parse it; otherwise assume it's already a Date
			const formatted_date = typeof date === "string" ? parseISO(date) : date;
			return format(formatted_date, "dd MMMM");
		},

		formatRepeatedEndDate(start, repeat) {
			if (!start || !repeat) return null;

			const endDate = addDays(parseISO(start), Number(repeat));
			return format(endDate, "dd MMMM");
		},

		formatTime(date) {
			return format(parseISO(date), "HH:mm");
		},
		/* 		getLocationTranslation(name) {
			let translated = name
			switch (name) {
				case '21 Beach Club':
					translated = this.__('21 Beach Club', 'ccave')
					break;
				case '21 Bistro Seaview':
					translated = this.__('21 Bistro Seaview', 'ccave')
					break;
				case 'Almara by Lustica Bay':
					translated = this.__('Almara by Lustica Bay', 'ccave')
					break;
				case 'Almara Sailboat':
					translated = this.__('Almara Sailboat', 'ccave')
					break;
				case 'Amphitheatre':
					translated = this.__('Amphitheatre', 'ccave')
					break;
				case 'Big Breakwater':
					translated = this.__('Big Breakwater', 'ccave')
					break;
				case 'Centrale':
					translated = this.__('Centrale', 'ccave')
					break;
				case 'Centrale Basketball Court':
					translated = this.__('Centrale Basketball Court', 'ccave')
					break;
				case 'Centrale Bocce Court':
					translated = this.__('Centrale Bocce Court', 'ccave')
					break;
				case 'Centrale Piazza':
					translated = this.__('Centrale Piazza', 'ccave')
					break;
				case 'Centrale Tennis Court':
					translated = this.__('Centrale Tennis Court', 'ccave')
					break;
				case 'Centrale Volleyball Court':
					translated = this.__('Centrale Volleyball Court', 'ccave')
					break;
				case 'Ciao Bella Gelateria':
					translated = this.__('Ciao Bella Gelateria', 'ccave')
					break;
				case '21 Beach Club':
					translated = this.__('21 Beach Club', 'ccave')
					break;
				case '21 Beach Club':
					translated = this.__('21 Beach Club', 'ccave')
					break;
				
			}
			return translated
		} */
	},
};
</script>
